var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button, theme } from '@robinpowered/ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import styled from '@emotion/styled';
/**
 * The dashed "add" button used to reveal a collapsed/optional composer section
 * (People, Space, Description, Video conference) and for inner add actions
 * (Add service request, Add buffer, Another space).
 *
 * Matches the Figma "Button" dashed pattern: full-width, dashed border, leading
 * plus icon, muted left-aligned label.
 */
export var AddSectionButton = function (_a) {
    var label = _a.label, onClick = _a.onClick, disabled = _a.disabled, loading = _a.loading;
    var token = theme.useToken().token;
    return (_jsx(AddBufferButton, { type: "dashed", block: true, token: token, icon: _jsx(FontAwesomeIcon, { icon: faPlus, size: "xs" }), onClick: onClick || (function () { }), disabled: disabled, style: {
            justifyContent: 'flex-start',
        }, loading: loading, children: label }));
};
var AddBufferButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  box-shadow: none;\n  color: ", ";\n  border-color: ", ";\n"], ["\n  width: 100%;\n  box-shadow: none;\n  color: ", ";\n  border-color: ", ";\n"])), function (_a) {
    var token = _a.token;
    return token.colorTextPlaceholder;
}, function (_a) {
    var token = _a.token;
    return token.colorBorderSecondary;
});
var templateObject_1;
